import React, { ReactElement } from 'react'
import { CONTROLDText } from 'ui/CONTROLD'
import { navigate } from 'gatsby'
import { MainContentContainer, TitleSection } from '../NewStaticPage'
import { Flex, Text } from 'theme-ui'
import { Button, Svg } from 'ui'
import SuccessIcon from 'images/success-page-icon.svg'
import ButtonArrow from 'images/button-arrow-right.svg'

export default function SuccessView(): ReactElement {
  return (
    <Flex sx={{ flexDirection: 'column' }}>
      <TitleSection>Success!</TitleSection>
      <MainContentContainer
        sxContainer={{
          width: ['100%', '62.8rem'],
          p: ['1.6rem', '4rem'],
        }}
      >
        <Flex
          sx={{
            gap: '1.6rem',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Svg
            svg={SuccessIcon}
            sx={{ width: '8rem', height: '8rem' }}
            descriptiveText="Success checkmark"
          />
          <Text variant="size16Weight400Line140" sx={{ color: 'lightSteelBlue' }}>
            Thanks. We&apos;ve sent you an email confirming the details of the transaction.
          </Text>
          <Button
            ariaLabel="configure control d"
            variant="gradientButton"
            sx={{
              width: 'fit-content',
              minWidth: '17rem',
              height: '4.7rem',
              alignItems: 'center',
              justifyContent: 'center',
              '& > div': {
                justifyContent: 'center',
              },
            }}
            onClick={() => navigate('/dashboard/profiles', { state: { login: true } })}
          >
            <Text variant="size18Weight500Line140">Configure {CONTROLDText}</Text>
            <Svg svg={ButtonArrow} sx={{ ml: '0.8rem' }} descriptiveText="Right arrow" />
          </Button>
        </Flex>
      </MainContentContainer>
    </Flex>
  )
}
